import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";

export const ApiariesCont = styled.div<{ $noBorder?: boolean }>`
    display: flex;
    gap: ${toRem(9)};
    flex-direction: column;
    width: calc(100% - ${toRem(16)});
    margin-bottom: ${toRem(2)};
    border-bottom: ${({ $noBorder }) =>
    $noBorder ? "none" : `${toRem(1)} solid ${COLORS.BORDER.MUTED}`};
    max-height: calc(100% - ${toRem(50)});
    overflow: hidden auto;
`;

export const Apiary = styled.div<{ $active?: boolean }>`
    display: flex;
    cursor: pointer;
    align-items: center;
    gap: ${toRem(10)};
    padding: ${toRem(4)} ${toRem(12)};
    border-radius: ${toRem(8)};
    transition: all 0.3s ease-in-out;
    position: relative;

    /* div *, div h2, div p {
        color: #000;
    } */

    &:hover {
        background: ${COLORS.NEUTRAL.CONTAINER_SOFT};
    }

    &:not(:last-of-type):after{
      content:'';
      position: absolute;
      width: 100%;
      height: ${toRem(1)};
      background-color: ${COLORS.BORDER.MUTED};
      left: 0;
      top: calc(100% + ${toRem(4)});
    }

    ${({ $active }) =>
    $active &&
    `
      background: ${COLORS.ACCENT.CONTAINER_SOFT};
      &:hover{background: ${COLORS.ACCENT.CONTAINER_SOFT};}
      div *, div h2, div p {
        color: ${COLORS.ACCENT.DEFAULT};
      }
    `}
`;


export const ApiaryTextCont = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${toRem(2)};
`
export const HiveCount = styled.p`
    display: flex;
    color: #686868ff;
    font-size: ${toRem(12)};
`

export const ApiaryTitle = styled.h3`
    color: ${COLORS.FG.DEFAULT};
    font-size: ${toRem(14)};
    line-height: ${20 / 14};
    font-weight: 400;
`

export const ApiarySubtitle = styled.p`
    color: ${COLORS.FG.DEFAULT};
    font-size: ${toRem(12)};
    font-weight: 400;
    line-height: ${16 / 12};
    letter-spacing: ${toRem(0.2)};
`
